// src/useToolSidebar.ts
import { useEffect, useState } from "react";
var emptyBrowse = () => ({ category: null, query: "", scrollTop: 0 });
function readBrowse(value) {
  if (!value || typeof value !== "object") return emptyBrowse();
  const saved = value;
  return {
    category: typeof saved.category === "string" ? saved.category : null,
    query: typeof saved.query === "string" ? saved.query : "",
    scrollTop: typeof saved.scrollTop === "number" && Number.isFinite(saved.scrollTop) && saved.scrollTop >= 0 ? saved.scrollTop : 0
  };
}
function useToolSidebar(storageKey = "genie.workspace.tool-sidebar") {
  const [preference, setPreference] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) ?? "null");
      return { open: saved?.open !== false, side: saved?.side === "right" ? "right" : "left", browse: { node: readBrowse(saved?.browse?.node), artboard: readBrowse(saved?.browse?.artboard) } };
    } catch {
      return { open: true, side: "left", browse: { node: emptyBrowse(), artboard: emptyBrowse() } };
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(preference));
    } catch {
    }
  }, [preference, storageKey]);
  useEffect(() => {
    const onKeyDown = (event) => {
      if (!event.altKey || event.metaKey || event.ctrlKey || event.code !== "Backslash" || event.repeat || event.defaultPrevented) return;
      const target = event.target;
      if (target?.closest('input, textarea, select, [contenteditable="true"]')) return;
      event.preventDefault();
      setPreference((current) => ({ ...current, open: !current.open }));
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);
  return {
    ...preference,
    setOpen: (open) => setPreference((current) => ({ ...current, open })),
    setSide: (side) => setPreference((current) => ({ ...current, side })),
    toggle: () => setPreference((current) => ({ ...current, open: !current.open })),
    setBrowse: (kind, value) => setPreference((current) => {
      const next = typeof value === "function" ? value(current.browse[kind]) : value;
      return { ...current, browse: { ...current.browse, [kind]: next } };
    })
  };
}

export {
  useToolSidebar
};
//# sourceMappingURL=chunk-DMHCGGZ2.js.map